/* External */
import {
  memo,
  createContext,
  useReducer,
  useContext,
} from 'react';
import PropTypes from 'prop-types';

/* Utils */
import { reducer, initialState } from './loadingStore';

// TODO Review this approach, if it needs to be integrated with the
// current redux store.
export const LoadingStoreContext = createContext(undefined);

function LoadingProvider({ children }) {
  return (
    <LoadingStoreContext.Provider value={useReducer(reducer, initialState)}>
      {children}
    </LoadingStoreContext.Provider>
  );
}

LoadingProvider.defaultProps = {
  children: undefined,
};

LoadingProvider.propTypes = {
  children: PropTypes.node,
};

export const useStore = () => useContext(LoadingStoreContext);
export default memo(LoadingProvider);
